export default __webpack_public_path__ + "static/media/company-logo6.213a3615.png";